module.exports = __webpack_public_path__ + "img/img4.2a5a1e76.png";